import { createFileRoute } from '@tanstack/react-router';
import { useCallback, useState } from 'react';
import { guardedClient as guardedRequest } from '@repo/shared/helpers';
import { useBreadcrumbLevel } from '@repo/components/hooks';

export const Route = createFileRoute('/_admin/system/assets')({
	component: AssetsPage,
});

function AssetsPage() {
	const [loaded, setLoaded] = useState(0);

	useBreadcrumbLevel(0, 'System');
	useBreadcrumbLevel(1, 'Assets');

	const _uploadFile = useCallback(async (formData: FormData) => {
		const file = formData.get('file') as File;
		if (!file) {
			throw new Error('No file provided');
		}
		const {
			body: { url, fields },
		} = await guardedRequest.get<undefined, { url: string; fields: Record<string, string> }>(
			`/api/files/upload-form-creds/${file.name}`,
			{ schema: undefined },
		);

		Object.entries(fields).forEach(([key, value]) => {
			formData.append(key, value);
		});

		const xhr = new XMLHttpRequest();
		xhr.open('POST', url);
		xhr.send(formData);

		return new Promise((resolve, reject) => {
			xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response);
				} else {
					reject(new Error('Upload failed'));
				}
			};
			xhr.upload.onprogress = (event) => {
				if (event.lengthComputable) {
					const percentComplete = Math.round((event.loaded / event.total) * 100);
					setLoaded(percentComplete);
				}
			};
			xhr.onerror = () => reject(new Error('Upload failed'));
		});
	}, []);

	return <div className="p-4">Assets - {loaded}% uploaded</div>;
}
